import './policy-position-sub-page-card.scss';
import './policy-position-sub-page-card.html.twig';
